module.exports = __webpack_public_path__ + "img/Leong_Goh.9fe88ea6.png";